<style>
.purchase .ivu-steps-item .ivu-steps-title {
    color: #666 !important;
}
</style>
<template>
    <div class="purchase">
        <compWrapper
            :title="
                $t('boss.purchase.purchase_order', { defaultValue: '采购单' })
            "
            theme="primary"
        >
            <section class="relative">
                <vForm
                    :label-width="100"
                    :model="formData"
                    class="clearfix margin-15"
                    :class="{ b2corder: type == 'query' }"
                    ref="applicateform"
                >
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.project', {
                                    defaultValue: '项目',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ getLineName(formData.lineId) }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.supplier', {
                                    defaultValue: '供应商',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ getSupplier(formData.supplierId) }}
                            </div>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_order_number', {
                                    defaultValue: '采购单号',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.orderNo || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.document_status', {
                                    defaultValue: '单据状态',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ getstatus(formData.orderStatus) }}
                            </div>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_currency', {
                                    defaultValue: '采购币种',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.currency }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.procurement_model', {
                                    defaultValue: '采购模式',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{
                                    getBuyMode(
                                        formData.paymentType,
                                        "paymentType"
                                    ).label || "--"
                                }}
                            </div>
                        </vFormItem>
                    </vCol>

                    <!-- <vCol span="12">
                        <vFormItem label="是否需要验货">
                            <div
                                class="font-weight"
                            >{{formData.isNeedInspect == 0 ? '否' : '是'}}</div>
                        </vFormItem>
                    </vCol> -->
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchaser', {
                                    defaultValue: '采购员',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{
                                    getBuyMode(formData.poUserId, "poUserId")
                                        .label || "--"
                                }}
                            </div>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.delivery_time', {
                                    defaultValue: '预计交货时间',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.expectedDeliveryDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.buyer', {
                                    defaultValue: '买方',
                                })
                            "
                        >
                            <vSelect
                                v-model="formData.buyerType"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="item in getBuyType"
                                    :value="item.value"
                                    :key="item.key"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.payer', {
                                    defaultValue: '付款方',
                                })
                            "
                        >
                            <vSelect
                                v-model="formData.poPurchaserId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="(item, index) in purchaserList"
                                    :value="item.id"
                                    :key="index"
                                    >{{ item.purchaserName }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <!-- <vCol span="12">
                        <vFormItem label="采购方">
                            <div
                                class="font-weight"
                            >{{getBuyMode(formData.poPurchaserId,'poPurchaserId').purchaserName || '--'}}</div>
                        </vFormItem>
                    </vCol> -->

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.payment_term_days', {
                                    defaultValue: '付款账期(天)',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.paymentDay || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.prepayment_ratio', {
                                    defaultValue: '预付款比例(%)',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.paymentRate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.payment_instructions', {
                                    defaultValue: '付款说明',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.paymentExplain || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.batch_number', {
                                    defaultValue: '批次号',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.refNo || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.reference_no', {
                                    defaultValue: '参考号',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.inboundRefNo || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.contract_signing', {
                                    defaultValue: '合同签订日期',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.contractSignDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>

                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.warehouse', {
                                    defaultValue: '预计接收仓库',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{
                                    formData.expectedReceiveWarehouseCode ||
                                    "--"
                                }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <!-- <vCol span="12">
                        <vFormItem label="预计验货日期">
                            <div class="font-weight">{{formData.expectedInspectDate || '--'}}</div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem label="验货人员">
                            <div class="font-weight">{{formData.inspectPersonName || '--'}}</div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem label="验货状态">
                            <div
                                class="font-weight"
                            >{{formData.inspectStatus == 0 ? '末验货' : formData.inspectStatus == 1 ? '验货合格' : "验货不合格"}}</div>
                        </vFormItem>
                    </vCol> -->
                    <vCol span="12" v-if="showaccount">
                        <vFormItem
                            :label="
                                $t('boss.purchase.ONITE_channel', {
                                    defaultValue: 'ONSITE渠道',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.channelFlag || "--" }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.ONITE_channel', {
                                    defaultValue: 'ONSITE渠道',
                                })
                            "
                            :rules="required"
                            prop="channelFlag"
                            v-else
                        >
                            <vSelect
                                clearable
                                filterable
                                v-model="formData.channelFlag"
                            >
                                <vOption
                                    v-for="(item, index) in channelList"
                                    :key="index"
                                    :value="item.accountFlag"
                                    >{{ item.accountFlag }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <!-- <vCol span="12">
                        <vFormItem label="关联入库计划单">
                            <div class="font-weight">{{stringNos || '--'}}</div>
                        </vFormItem>
                    </vCol> -->
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.notes', {
                                    defaultValue: '备注',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.remark || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                </vForm>
            </section>
            <template v-if="type != 'query'" slot="footer">
                <vButton
                    class="margin-right-20"
                    theme="primary"
                    @click="submit"
                    >{{
                        $t("boss.purchase.save", { defaultValue: "保存" })
                    }}</vButton
                >
                <!-- <vButton class="margin-right-20" theme="info" @click="submit">保存为草稿</vButton> -->
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("boss.purchase.cancel", { defaultValue: "取消" })
                }}</vButton>
            </template>
        </compWrapper>
        <compWrapper
            :title="
                $t('boss.purchase.risk_control', {
                    defaultValue: '金融风控信息',
                })
            "
            theme="warning"
        >
            <vForm
                :label-width="120"
                class="clearfix margin-15"
                :model="poOrderFk"
                ref="fkform"
            >
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.funding_party', {
                                defaultValue: '资金方',
                            })
                        "
                        prop="funderName"
                        :rules="required"
                    >
                        <vSelect
                            v-model="poOrderFk.funderId"
                            @on-change="getRate(poOrderFk.funderId)"
                        >
                            <vOption
                                v-for="item in funderList"
                                :key="item.key"
                                :value="item.id"
                                >{{ item.funderName }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.exchange_rate', {
                                defaultValue: '汇率',
                            })
                        "
                        prop="exchangeRate"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.exchangeRate"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.contract_number', {
                                defaultValue: '合同编号',
                            })
                        "
                        prop="referenceNo"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.referenceNo"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.purchase_contract_information", {
                                defaultValue: "采购合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_time', {
                                defaultValue: '提货时间',
                            })
                        "
                        prop="pickUpTime"
                        :rules="required"
                    >
                        <vDatepicker
                            type="date"
                            v-model="poOrderFk.pickUpTime"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.shortage_ratio', {
                                defaultValue: '溢短装比例(%)',
                            })
                        "
                        prop="exceedRatio"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.exceedRatio"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_fund', {
                                defaultValue: '风险金',
                            })
                        "
                        prop="advance"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.advance"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_fund_requirement', {
                                defaultValue: '风险金要求',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.advanceRequirement"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.procurement_contract', {
                                defaultValue: '采购合同结算方式',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.purchaseSettlementMethod"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.money_transfer", {
                                    defaultValue: "汇款",
                                })
                            }}</vOption>
                            <vOption :value="2">{{
                                $t("boss.purchase.transfer_accounts", {
                                    defaultValue: "转账",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <!-- <vCol span="8">
                    <vFormItem label="结算天数">
                        <vInput v-model="poOrderFk.purchaseSettlementDays"></vInput>
                    </vFormItem>
                </vCol> -->
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_address', {
                                defaultValue: '提货地址',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.pickUpAddress"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_method', {
                                defaultValue: '提货方式',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.pickUpMethod"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.consignee', {
                                defaultValue: '提货人',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.consignee"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.consignee_phone', {
                                defaultValue: '提货人联系电话',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.phone"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_requirements', {
                                defaultValue: '提货要求',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.pickUpRequirement"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.export_contract_Information", {
                                defaultValue: "外销合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.latest_delivery_date', {
                                defaultValue: '最迟交货日期',
                            })
                        "
                        prop="latestDeliveryTime"
                        :rules="required"
                    >
                        <vDatepicker
                            type="date"
                            v-model="poOrderFk.latestDeliveryTime"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_method', {
                                defaultValue: '外销合同结算方式',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.exportSettlementMethod"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.money_transfer", {
                                    defaultValue: "汇款",
                                })
                            }}</vOption>
                            <vOption :value="2">{{
                                $t("boss.purchase.transfer_accounts", {
                                    defaultValue: "转账",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_export_contracts', {
                                defaultValue: '外销合同结算天数',
                            })
                        "
                        prop="exportSettlementDays"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.exportSettlementDays"></vInput> -->
                        <vSelect
                            clearable
                            v-model="poOrderFk.exportSettlementDays"
                            @on-attach="getProtocolItemId"
                        >
                            <vOption
                                v-for="item in exportContractDayList"
                                :value="item.billPeriod"
                                :attach="item.protocolItemId"
                                :key="item.protocolItemId"
                                >{{ item.financin }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.currency_settlement', {
                                defaultValue: '外销合同结算币种',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.exportSettlementCurrency"
                        >
                            <vOption value="USD">USD</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.trade_term', {
                                defaultValue: '贸易术语',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.tradeTerm"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_location', {
                                defaultValue: '交货地点',
                            })
                        "
                    >
                        <vInput
                            v-model="poOrderFk.deliveryAddress"
                            :placeholder="
                                $t('boss.purchase.freight_forwarder', {
                                    defaultValue: '货代提货点',
                                })
                            "
                        ></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.other_information", {
                                defaultValue: "其它信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.domestic_transportation', {
                                defaultValue: '国内运输',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.domesticTransport"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.other_information", {
                                    defaultValue: "国内运输",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.initial_transportation', {
                                defaultValue: '头程运输',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.firstWayTransport"
                        >
                            <vOption
                                v-for="item in transoprtList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.storage_services', {
                                defaultValue: '仓储服务',
                            })
                        "
                    >
                        <vSelect clearable v-model="poOrderFk.warehouseService">
                            <vOption :value="0">{{
                                $t("boss.purchase.not_enabled", {
                                    defaultValue: "不启用",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.enabled", {
                                    defaultValue: "启用",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_service', {
                                defaultValue: '配送服务',
                            })
                        "
                    >
                        <vSelect clearable v-model="poOrderFk.deliveryService">
                            <vOption :value="0">{{
                                $t("boss.purchase.not_enabled", {
                                    defaultValue: "不启用",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.enabled", {
                                    defaultValue: "启用",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>

                <vCol span="24">
                    <vFormItem
                        :label="
                            $t('boss.purchase.purchase_contract', {
                                defaultValue: '采购合同',
                            })
                        "
                        prop="purchaseContractMeta"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.purchaseContractMeta"></vInput> -->
                        <Button
                            type="success"
                            v-if="purchaseList.length == 0"
                            @click="purchaseUpload"
                            >{{
                                $t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            }}</Button
                        >
                    </vFormItem>
                    <Table
                        class="margin-25"
                        :columns="purchaseColumns"
                        :data="purchaseList"
                        size="small"
                        ref="table1"
                        border
                    ></Table>
                </vCol>
                <vCol span="24">
                    <vFormItem
                        :label="
                            $t('boss.purchase.export_contract', {
                                defaultValue: '外销合同',
                            })
                        "
                        prop="exportContractMeta"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.exportContractMeta"></vInput> -->
                        <Button
                            type="success"
                            v-if="exportList.length == 0"
                            @click="exportUpload"
                            >{{
                                $t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            }}</Button
                        >
                    </vFormItem>
                    <Table
                        class="margin-25"
                        :columns="exportColumns"
                        :data="exportList"
                        size="small"
                        ref="table2"
                        border
                    ></Table>
                </vCol>
            </vForm>
        </compWrapper>

        <!-- 两种弹框全局弹框 1:简便弹框包含alert和formdata -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps.show = false"
            @on-close="closemodalprops"
        >
            <component
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="closemodalprops"
                v-on="modalProps.on"
            />
        </compModal>

        <!-- 2：自定义弹框内容，包含component -->
        <vModal
            v-model="handle.show"
            :title="handle.title"
            :width="handle.width || 460"
            :showFooter="false"
        >
            <component
                :is="handle.component"
                v-bind="handle"
                @on-close="handle.show = false"
                v-on="handle.on"
            ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </vModal>

        <vModal
            v-model="upload.show"
            :title="upload.title"
            v-bind="upload"
            :showFooter="false"
        >
            <compMutiUpload
                v-bind="mutiFileProps"
                @on-success="uploadSuccess"
                @on-cancel="cancelMutiUpload"
            ></compMutiUpload>
        </vModal>

        <vModal
            class="hidefooter"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetOrderOne,
    HttpReplenishFKInfo,
    HttpFindByOrgIdAndOrgWarehouseId,
    HttpDelAttach,
    HttpDelAttachNew,
    HttpDelAttachPurchase,
    HttpDelAttachExport,
    HttpFindProvidersByOrg,
    HttpGetPurchaserList,
} from "@/service/purchase/purchase";

import delivery from "./delivery";
import comInspection from "./inspection";

import { HttpGetErpsku } from "@/service/aftersales/aftersales";
import { HttpSysOpLog } from "@/service/boss/allot";

import compCheck from "./compcheck";
import mixin from "../../mixin";
export default {
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compUpload: () => import("@components/templates/upload"),
        compModal: () => import("@components/templates/modal"),
        compCheck,
        delivery,
        comInspection,
    },
    props: ["activeid"],
    mixins: [mixin],
    data() {
        return {
            // id: this.$route.query.id,
            id: this.activeid ? this.activeid : 0,
            formData: {
                lineId: "",
                currency: "USD",
                paymentType: "undefined",
                paymentRate: "",
                poUserId: this.$store.state.userinfo.id,
            },
            poOrderFk: {
                exceedRatio: "5",
                exportSettlementCurrency: "USD",
            },
            exportContractDayList: [],
            buyModeList: [
                {
                    value: "payment",
                    label: this.$t("boss.purchase.self_procurement", {
                        defaultValue: "自采",
                    }),
                },
                {
                    value: "unpayment",
                    label: this.$t("boss.purchase.agency_operations", {
                        defaultValue: "代运营",
                    }),
                },
                {
                    value: "fk",
                    label: this.$t(
                        "boss.purchase.financial_procurement_agency",
                        {
                            defaultValue: "金融代采",
                        }
                    ),
                },
                {
                    value: "undefined",
                    label: this.$t("boss.purchase.other", {
                        defaultValue: "其他",
                    }),
                },
            ],
            updatestatus: [],
            showaccount: false,
            // modal1:false,
            logList: [],
            docList: [],
            loading: false,
            datalist2: [],
            allnumber: 0,
            allacount: 0,
            allamount: 0,
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            operate: {
                id: null,
                title: "",
                show: false,
                actionurl: "",
                name: "",
                boxtype: "",
                downexcel: "",
                component: null,
            },
            handle: {
                show: false,
                title: "",
                component: null,
            },
            modalProps: {
                show: false,
            },
            poOrderItem: [],
            stringNos: "",
            channelList: [],
            funderList: [],
            purchaseList: [],
            exportList: [],
            rateDisabled: false,
            upload: {
                show: false,
            },
            purchaserList: [],
        };
    },
    created() {
        console.log(this.$route, this.activeid);
        this.update();
    },
    computed: {
        ...mapState("boss", ["userinfo"]),
        ...mapGetters("diction", [
            "getNewProductList",
            "getAllSupplier",
            "getNewDifferentAllProductList",
        ]),
        ...mapGetters("dictionary", [
            "getFBBFilterDisabledAllWarehouse",
            "getAllProductPerson",
        ]),
        getUserList() {
            return this.getAllProductPerson.filter(function (item) {
                // console.log(item)
                return item.label != "";
            });
        },
        transoprtList() {
            return [
                {
                    value: 1,
                    label: this.$t("boss.purchase.international_shipping", {
                        defaultValue: "国际海运",
                    }),
                },
                {
                    value: 2,
                    label: this.$t(
                        "boss.purchase.international_air_transport",
                        {
                            defaultValue: "国际空运",
                        }
                    ),
                },
                {
                    value: 3,
                    label: this.$t(
                        "boss.purchase.international_land_transportation",
                        {
                            defaultValue: "国际陆运",
                        }
                    ),
                },
            ];
        },
        mutiFileProps() {
            return {
                data: {
                    srcLabel: this.id || 0,
                    model: this.upload.model,
                    type: "other",
                },
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: false,
            };
        },
        getFileProps() {
            if (this.operate.downexcel) {
                return {
                    data: {
                        sourceId: this.id || 0,
                        supplierId: this.formData.supplierId || 0,
                        currency: this.formData.currency,
                    },
                    action: this.operate.actionurl,
                    name: this.operate.name,
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS +
                                this.operate.downexcel,
                            {},
                            "download"
                        );
                    },
                };
            } else {
                return {
                    data: {
                        srcLabel: this.id || 0,
                        model: "po_order",
                        type: "other",
                    },
                    action: this.operate.actionurl,
                    name: this.operate.name,
                };
            }
        },
        purchaseColumns() {
            let that = this;
            let result = [
                {
                    title: this.$t("boss.purchase.purchase_contract_name", {
                        defaultValue: "采购合同名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.contract_link", {
                        defaultValue: "合同链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        let button = h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.downloadAttach(0, index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                        if (that.type !== "query") {
                            button = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.downloadAttach(0, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "10px",
                                        },
                                    },
                                    this.$t("boss.purchase.download", {
                                        defaultValue: "下载",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.removePurchase(index);
                                            },
                                        },
                                    },
                                    this.$t("boss.purchase.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                        return h("div", [button]);
                    },
                },
            ];
            return result;
        },
        exportColumns() {
            let that = this;
            let result = [
                {
                    title: this.$t("boss.purchase.export_contract_name", {
                        defaultValue: "外销合同名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.contract_link", {
                        defaultValue: "合同链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        let button = h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.downloadAttach(1, index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                        if (that.type !== "query") {
                            button = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.downloadAttach(1, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "10px",
                                        },
                                    },
                                    this.$t("boss.purchase.download", {
                                        defaultValue: "下载",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.removeExport(index);
                                            },
                                        },
                                    },
                                    this.$t("boss.purchase.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                        return button;
                    },
                },
            ];
            return result;
        },
    },
    methods: {
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        getRate(funderId) {
            let rateItem = this.funderList.filter((item) => {
                return funderId === item.id;
            })[0];
            // 外销合同天数修改
            this.exportContractDayList = this.arrayUnique(
                rateItem.protocolDetailListMap,
                "protocolItemId"
            );
            if (rateItem) {
                this.poOrderFk.exchangeRate = rateItem.rate;
                // 新增字段
                this.poOrderFk.funderName = rateItem.funderName;
                this.poOrderFk.funderNameEn = rateItem.funderNameEn;
                this.poOrderFk.funderAddress = rateItem.address;
                this.poOrderFk.funderAddressEn = rateItem.addressEn;
                this.poOrderFk.funderContactPhone = rateItem.phone;
                this.poOrderFk.funderContactName = rateItem.contactName;
                this.rateDisabled = true;
            } else {
                this.poOrderFk.rate = "";
            }
        },
        getProtocolItemId(protocolItemId) {
            this.poOrderFk.protocolItemId = protocolItemId;
        },
        getFunderName(value) {
            let funder = this.funderList.filter((item) => {
                return value === item.id;
            })[0];
            if (funder) return funder.funderName;
            return "--";
        },
        downloadAttach(type, index) {
            let fileUrl = "";
            switch (type) {
                // 采购合同
                case 0:
                    fileUrl = this.purchaseList[index].attachUrl;
                    break;
                // 外销合同
                case 1:
                    fileUrl = this.exportList[index].attachUrl;
                    break;
            }
            this.handleWebfs(fileUrl, {}, "download");
        },
        async removePurchase(index) {
            await this.delAttach(this.purchaseList[index].attachId, "purchase");
            this.purchaseList.splice(index, 1);
        },
        async removeExport(index) {
            await this.delAttach(this.exportList[index].attachId, "export");
            this.exportList.splice(index, 1);
        },
        cancelMutiUpload() {
            this.upload.show = false;
        },
        async delAttach(id, type) {
            // 新增时删除附件用另外的接口
            if (this.type === "add") {
                await HttpDelAttachNew({
                    id: id,
                }).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
            // 编辑
            else {
                let httpDelFunc = HttpDelAttachPurchase;
                if (type === "export") {
                    httpDelFunc = HttpDelAttachExport;
                }
                await httpDelFunc({
                    id: this.id || 0,
                    attachId: id,
                }).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
        },
        purchaseUpload() {
            this.upload = {
                show: true,
                title: this.$t("boss.purchase.purchase_contract_upload", {
                    defaultValue: "采购合同上传",
                }),
                model: "po_order_fk_purchase",
            };
        },
        exportUpload() {
            this.upload = {
                show: true,
                title: this.$t("boss.purchase.upload_export_contract", {
                    defaultValue: "外销合同上传",
                }),
                model: "po_order_fk_export",
            };
        },
        uploadSuccess(res) {
            let list = [];
            // 采购合同
            if (this.upload.model === "po_order_fk_purchase") {
                list = this.purchaseList;
            }
            // 外销合同
            else {
                list = this.exportList;
            }
            res.items.map((item) => {
                list.push(item);
            });
            this.cancelMutiUpload();
        },
        getTransport(value) {
            let result =
                this.transoprtList.filter((item) => {
                    return value === item.value;
                })[0] || undefined;
            if (!result) return "--";
            return result.label;
        },
        getBuyMode(type, status) {
            switch (status) {
                case "paymentType":
                    return (
                        this.buyModeList.filter((item) => {
                            return item.value === type;
                        })[0] || {}
                    );
                    break;
                case "poUserId":
                    return (
                        this.getUserList.filter((item) => {
                            return item.value === type;
                        })[0] || {}
                    );
                    break;
                case "poPurchaserId":
                    return (
                        this.purchaserList.filter((item) => {
                            return item.id === type;
                        })[0] || {}
                    );
                    break;
            }
        },
        getNewWarehouseCode(id) {
            // console.log(id,'8888')
            if (id == 0) return;
            this.getFBBFilterDisabledAllWarehouse.map((item) => {
                if (id === item.value) {
                    this.formData.expectedReceiveWarehouseCode =
                        item.attach.code;
                }
            });
            this.getChannel(this.formData.expectedReceiveWarehouseCode);
        },
        getSupplier(sulierid) {
            // console.log(sulierid)
            let itemarr =
                this.getAllSupplier.filter((item) => {
                    return item.value == sulierid;
                })[0] || {};

            return itemarr.label || "--";
        },
        getLineName(id) {
            let json =
                this.getNewDifferentAllProductList.filter((item) => {
                    return item.value == id;
                })[0] || {};
            return json.label || "--";
        },
        getstatus(type) {
            switch (type) {
                case "draft":
                    return this.$t("boss.purchase.draft", {
                        defaultValue: "草稿",
                    });
                    break;
                case "submit":
                    return this.$t("boss.purchase.submitted", {
                        defaultValue: "已提交",
                    });
                    break;
                case "auditing_pass":
                    return this.$t("boss.purchase.approved", {
                        defaultValue: "审核通过",
                    });
                    break;
                case "finished":
                    return this.$t("boss.purchase.completed", {
                        defaultValue: "已完成",
                    });
                    break;
                case "canceled":
                    return this.$t("boss.purchase.cancelled", {
                        defaultValue: "已取消",
                    });
                    break;
                case "auditing_refused":
                    return this.$t("boss.purchase.review_rejected", {
                        defaultValue: "审核驳回",
                    });
                    break;
            }
        },
        getallnumber() {
            let accounts = 0;
            let amounts = 0;
            let skuArr = [];
            this.datalist2.map((item) => {
                skuArr.push(item.erpsku);
                accounts += Number(item.quantity);
                amounts += Number(item.price * item.quantity);
            });
            this.allnumber = new Set(skuArr).size;
            this.allacount = accounts;
            this.allamount = amounts.toFixed(4);
        },
        getChannel(wacode) {
            // console.log(wacode)
            let wajsonone =
                this.getFBBFilterDisabledAllWarehouse.filter((item) => {
                    return item.attach.code == wacode;
                })[0] || {};
            // console.log(wajsonone)
            if (wajsonone.attach.warehouseType !== 4) {
                this.showaccount = false;
                return;
            }
            let wareId = wajsonone.value;
            this.showaccount = true;
            HttpFindByOrgIdAndOrgWarehouseId({
                orgId: global.SYSID,
                orgWarehouseId: wareId,
            }).then(
                (res) => {
                    this.channelList = [];
                    this.channelList = res.data;
                },
                (err) => {
                    this.$$VMessage.error(err.message);
                }
            );
        },
        async update() {
            // if (this.querytype) {
            //     this.id = this.activeid;
            //     this.type = this.querytype;
            // } else {
            //     this.id = this.$route.query.id;
            //     this.type = this.type;
            // }
            HttpGetPurchaserList().then(
                (res) => {
                    this.purchaserList = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            // 默认获取当天的合同签订日期
            // contractSignDate
            this.formData.contractSignDate = this.getDay(0);

            // if (this.type == "add") return;
            this.loading = true;
            HttpFindProvidersByOrg().then(
                (res) => {
                    // console.log(res);
                    this.funderList = res.data || [];
                },
                (err) => {
                    this.funderList = [];
                }
            );
            // 详情
            if (this.type != "add") {
                await HttpGetOrderOne({
                    id: this.id,
                }).then(
                    (res) => {
                        // console.log(res,'9889')
                        this.loading = false;
                        this.formData = res.data;
                        this.updatestatus = [
                            {
                                label: this.$t("boss.purchase.draft", {
                                    defaultValue: "草稿",
                                }),
                                value: this.formData.createdAt.split(" ")[0],
                            },
                            {
                                label: this.$t("boss.purchase.submitted", {
                                    defaultValue: "已提交",
                                }),
                                value: this.formData.submitDate,
                            },
                            {
                                label: this.$t("boss.purchase.approved", {
                                    defaultValue: "审核通过",
                                }),
                                value: this.formData.auditingDate,
                            },
                            {
                                label: this.$t("boss.purchase.inspection", {
                                    defaultValue: "验货",
                                }),
                                value: this.formData.inspectDate,
                            },
                            {
                                label: this.$t(
                                    "boss.purchase.create_inventory_plan",
                                    {
                                        defaultValue: "创建入库计划",
                                    }
                                ),
                                value: this.formData.firstShipmentDate,
                            },
                            {
                                label: this.$t("boss.purchase.delivery", {
                                    defaultValue: "交货",
                                }),
                                value: this.formData.firstDeliverDate,
                            },
                            {
                                label: this.$t("boss.purchase.receive", {
                                    defaultValue: "接收",
                                }),
                                value: this.formData.firstReceiveDate,
                            },
                            {
                                label: this.$t("boss.purchase.completed", {
                                    defaultValue: "已完成",
                                }),
                                value: this.formData.finishDate,
                            },
                        ];
                        if (this.formData.poUserId == 0) {
                            this.formData.poUserId =
                                this.$store.state.userinfo.id;
                        }
                        // this.poOrderFk = res.data.poOrderFk ? res.data.poOrderFk : {};
                        this.datalist2 = res.data.poOrderItem;
                        this.purchaseList = res.data.poOrderFk
                            ? JSON.parse(
                                  res.data.poOrderFk.purchaseContractMeta
                              ).items
                            : [];
                        this.exportList = res.data.poOrderFk
                            ? JSON.parse(res.data.poOrderFk.exportContractMeta)
                                  .items
                            : [];
                        this.datalist2.map((item) => {
                            item.lineId = res.data.lineId;
                        });
                        this.formData.paymentRate =
                            res.data.paymentRate === null
                                ? ""
                                : res.data.paymentRate;
                        this.formData.paymentDay =
                            res.data.paymentDay === null
                                ? ""
                                : res.data.paymentDay;

                        this.docList = res.data.meta
                            ? JSON.parse(res.data.meta).items
                            : [];

                        this.getNewWarehouseCode(
                            res.data.expectedReceiveWarehouseId
                        );

                        this.getallnumber();

                        // 入库计划单获取
                        let arrNos = [];
                        (res.data.inboundPlanReceiveList || []).map((item) => {
                            let jsonone =
                                item.inboundPlanOrderNo +
                                " (" +
                                this.getinboundStatus(
                                    item.inboundPlanOrderStatus
                                ) +
                                ")";
                            arrNos.push(jsonone);
                        });
                        this.stringNos = arrNos.join(",");

                        // 展示渠道选择
                        if (this.formData.expectedReceiveWarehouseCode != "") {
                            // console.log(this.formData.expectedReceiveWarehouseCode)
                            let channelone =
                                this.getFBBFilterDisabledAllWarehouse.filter(
                                    (json) => {
                                        return (
                                            json.attach.code ==
                                            this.formData
                                                .expectedReceiveWarehouseCode
                                        );
                                    }
                                )[0] || {};
                            if (channelone.attach.warehouseType == 4) {
                                this.showaccount = true;
                            } else this.showaccount = false;

                            if (this.type == "edit") {
                                this.getChannel(
                                    this.formData.expectedReceiveWarehouseCode
                                );
                            }
                        }
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                        this.loading = false;
                    }
                );
            }
            if (this.type == "edit") {
                this.editshow = true;
                this.showwarehouse = true;
            }
        },
        getinboundStatus(inboundStus) {
            switch (inboundStus) {
                case 0:
                    return this.$t("fbb.inbound.draft", {
                        defaultValue: "草稿",
                    });
                    break;
                case 5:
                    return this.$t("fbb.inbound.check_pending", {
                        defaultValue: "待审核",
                    });
                    break;
                case 6:
                    return this.$t("fbb.inbound.approval_back", {
                        defaultValue: "审批拒回",
                    });
                    break;
                case 8:
                    return this.$t("fbb.inbound.for_packing", {
                        defaultValue: "待装箱",
                    });
                    break;
                case 10:
                    return this.$t("fbb.inbound.send_goods", {
                        defaultValue: "待发货",
                    });
                    break;
                case 20:
                    return this.$t("fbb.inbound.stock_pending", {
                        defaultValue: "待入库",
                    });
                    break;
                case 25:
                    return this.$t("fbb.inbound.inthe_library", {
                        defaultValue: "入库中",
                    });
                    break;
                case 70:
                    return this.$t("global.common.finished", {
                        defaultValue: "已完成",
                    });
                    break;
                case 100:
                    return this.$t("global.common.canceled", {
                        defaultValue: "已取消",
                    });
                    break;
            }
        },
        async submit() {
            if (this.$refs.fkform) {
                const valid = await this.$refs.fkform.validate();
                if (!valid) return;
                if (
                    this.purchaseList.length === 0 ||
                    this.exportList.length === 0
                ) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.purchase_and_export", {
                            defaultValue: "请上传采购合同和外销合同",
                        })
                    );
                }
                // this.formData.poOrderFk = this.poOrderFk;
            }
            if (
                this.poOrderFk.exchangeRate &&
                this.poOrderFk.exchangeRate < 1
            ) {
                this.$VMessage.error(
                    this.$t("boss.purchase.exchange_rate", {
                        defaultValue: "汇率填写必须大于0",
                    })
                );
                return;
            }
            if (this.purchaseList.length > 0) {
                this.poOrderFk.purchaseContractMeta = JSON.stringify({
                    items: this.purchaseList,
                    opAt: this.purchaseList[0].opAt,
                    organizationId: global.SYSID,
                });
            }
            if (this.exportList.length > 0) {
                this.poOrderFk.exportContractMeta = JSON.stringify({
                    items: this.exportList,
                    opAt: this.exportList[0].opAt,
                    organizationId: global.SYSID,
                });
            }
            let data = {
                orgId: global.SYSID,
                // ...this.formData,
                poOrderFk: this.poOrderFk,
            };
            let requestData = {
                orgId: global.SYSID,
                ...data,
                buyerType: this.formData.buyerType,
                poPurchaserId: this.formData.poPurchaserId,
                id: this.id,
            };
            this.loading = true;

            HttpReplenishFKInfo(requestData).then(
                (res) => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            // this.$router.push({
            //     name: "purchaseOrderList",
            // });
            this.$parent.$attrs.on["on-success"]();
        },
        // 点击上传附件之后的操作
        aaasuccess(res) {
            let arrtable = res.data;
            let flagArr = [];

            // erpsku去重
            let tempArr = arrtable.map((item) => {
                return item.erpsku;
            });
            let tempSet = new Set();
            tempArr.map((item) => {
                tempSet.add(item);
            });
            let result = Array.from(tempSet);
            for (let x = 0; x < result.length; x++) {
                for (let y = 0; y < arrtable.length; y++) {
                    if (!result[x].erpsku) {
                        if (result[x] === arrtable[y].erpsku) {
                            // 初始化，改变了数组数据结构
                            if (result[x].quantity === undefined) {
                                result[x] = arrtable[y];
                            } else {
                                result[x].quantity += arrtable[y].quantity;
                            }
                        }
                    } else {
                        if (result[x].erpsku === arrtable[y].erpsku) {
                            result[x].quantity += arrtable[y].quantity;
                        }
                    }
                }
            }
            this.datalist2.push(...result);

            this.getallnumber();
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
    },
};
</script>
